// extracted by mini-css-extract-plugin
module.exports = {"pendingPaymentBadge":"styles_pendingPaymentBadge__1gcNd"};